module.exports = __webpack_public_path__ + "static/media/templatesIcon.e2f9ca6e.svg";